<!-- TODO: Add translation here -->
<div
  class="px-5 pb-3 font-base lg:px-0"
  [style.color]="textColor | contentBuilderColor"
>
  @if (deliveryAmount) {
    <div class="flex justify-between border-b border-neutral-300 py-3">
      <div class="text-base font-normal leading-snug">
        {{ 'basket.delivery-costs' | translate }}
      </div>
      <div class="flex flex-row items-center justify-center">
        <div
          class="icon icon-bike pl-4"
          [style.color]="secondaryTextColor | contentBuilderColor"
        ></div>
        <div class="text-right text-base leading-5 whitespace-nowrap">
          <app-price-atom
            [bold]="false"
            [amount]="deliveryAmount"
            [format]="true"
          ></app-price-atom>
        </div>
      </div>
    </div>
  }
  @if (tips) {
    <div class="flex max-w-screen-sm items-center justify-between border-b border-neutral-300 py-3">
      <div class="mr-2 flex flex-1 items-start gap-2">
        <div
          class="icon icon-satisfied px-2"
          [style.color]="secondaryTextColor | contentBuilderColor"
        ></div>
        <div class="text-base font-normal leading-snug">
          {{ 'basket.additonnal-informations.tip' | translate }}
        </div>
      </div>
      <div class="text-right text-base leading-5 whitespace-nowrap">
        <app-price-atom
          [bold]="false"
          [amount]="tips"
          [format]="true"
        ></app-price-atom>
      </div>
    </div>
  }

  @if (!isBasketExist) {
    @for (coupon of coupons; track coupon.code ?? coupon.key ?? $index) {
      <div class="border-b border-neutral-300 py-3 text-base">
        <div
          class="flex justify-between"
          [class.opacity-50]="coupon.removeInProgress"
        >
          <div class="text-base font-normal leading-snug flex gap-2">
            @if (coupon.type !== 'ERROR') {
              <div
                class="icon icon-coupon-3 px-2"
                [style.color]="secondaryTextColor | contentBuilderColor"
              ></div>
            }
            @if (coupon.type === 'ERROR') {
              <div class="icon icon-warning-circle px-2 text-error-800"></div>
            }
            <div>
              @let voucherCustomName =
                'voucher-name.' + coupon.type | translate | appFn: ensureTranslated;
              @if (coupon.name || voucherCustomName) {
                {{ voucherCustomName ?? coupon.name }}
              }
              @if (!coupon.name) {
                {{ 'basket.discount-voucher' | translate }} «{{ coupon.code }}»
              }
            </div>
            @if (coupon.type === 'ERROR') {
              <div class="text-xs text-error-800">
                @if (coupon.error) {
                  {{ 'voucher-modal.voucher-not-available' | translate }}
                }
                @if (!coupon.error) {
                  {{ 'basket.invalid-voucher' | translate }}
                }
              </div>
            }
            @if (coupon.is_removable) {
              <a
                (click)="onRemoveCoupon(coupon)"
                class="cursor-pointer text-primary-600"
              >
                {{ 'basket.delete' | translate }}
              </a>
            }
          </div>
          <div class="flex flex-row items-center justify-end">
            @if (coupon.type !== 'ERROR') {
              <div class="text-right text-base leading-5 whitespace-nowrap">
                <app-price-atom
                  [bold]="false"
                  [amount]="coupon.amount_off * -1"
                  [format]="true"
                ></app-price-atom>
              </div>
            }
          </div>
        </div>
        @if (coupon.type === 'PREPAYMENT') {
          <div class="mt-2">
            <app-button-atom
              [label]="'disable-prepayment-modal.button' | translate"
              [type]="'outlined'"
              [color]="'neutral'"
              [size]="'XS'"
              [thickSize]="'XS'"
              (click)="onRemoveCoupon(coupon)"
            />
          </div>
        }
      </div>
    }
  }
  @if (usePointsAmount > 0) {
    <div class="flex justify-between border-b border-neutral-300 py-3">
      <div class="text-base font-normal leading-snug">
        <div>{{ 'basket.loyalty-credit' | translate }}</div>
        <div>
          <a
            (click)="removeUsePoints.emit()"
            class="text-primary-800"
          >
            {{ 'basket.remove' | translate }}
          </a>
        </div>
      </div>
      <span class="text-base leading-5"
        >-<app-price-atom
          [bold]="false"
          [amount]="usePointsAmount"
          [format]="true"
        ></app-price-atom
      ></span>
    </div>
  }
  <div
    class="flex justify-between py-3"
    [style.color]="headingColor | contentBuilderColor"
  >
    <span class="font-base text-base font-bold leading-6">{{
      'basket.amount-to-pay' | translate
    }}</span>
    <span class="font-base text-base font-bold leading-6"
      ><app-price-atom
        [amount]="totalAmount"
        [format]="true"
      ></app-price-atom
    ></span>
  </div>
</div>
